var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return undefined},proxy:true},{key:"footer",fn:function(){return undefined},proxy:true}])},[[_c('ContentTextEdit',{attrs:{"xmlJson":_vm.xmlJson}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }